import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from '../interfaces/producto.interface';
import { environment } from 'src/environments/environment';
import { Observable, catchError, throwError } from 'rxjs';
import { Reporte, ReporteForValidation } from '../interfaces/reporte.interface';
import { DetalleReporte } from '../interfaces/detalleReporte.interface';
import { RegistroService } from 'src/app/registro.service';
@Injectable({
    providedIn: 'root',
})
export class ProductoserviceService {
    apiSiriUrl: string = environment.apiSiriUrl;
    constructor(
        private http: HttpClient,
        private registroService: RegistroService
    ) {}

    async getProducts(): Promise<Observable<Product[]>> {
        const url = `${this.apiSiriUrl}producto/agente-vigilado/${this.registroService.empresaSelected}`;

        try {
            const products = await this.http.get<Product[]>(url).toPromise();
            return new Observable<Product[]>((observer) => {
                observer.next(products);
                observer.complete();
            });
        } catch (error) {
            return throwError(error);
        }
    }

    getComercializadorProducts(): Observable<any[]> {
        const url = `${this.apiSiriUrl}registros-comercializador/comercializador/${this.registroService.empresaSelected}`;
        return this.http.get<any[]>(url);
    }

    getReporte(id) {
        const url = `${this.apiSiriUrl}reporte/${id}`;
        return this.http.get<{}>(url);
    }

    getReporteComercializador(id) {
        const url = `${this.apiSiriUrl}reporte-comercializador/${id}`;
        return this.http.get<{}>(url);
    }

    loadSalesData(informacion: Reporte) {
        const url = `${this.apiSiriUrl}reporte`;
        return this.http
            .post<Reporte>(url, informacion)
            .pipe(catchError(this.handleErrorResponse));
    }
    loadDetalles(detalleReporte: DetalleReporte) {
        const url = `${this.apiSiriUrl}reporte/detalle/bulk`;
        return this.http
            .post<DetalleReporte>(url, detalleReporte)
            .pipe(catchError(this.handleErrorResponse));
    }

    loadDetallesComercializador(detalleReporte: DetalleReporte) {
        const url = `${this.apiSiriUrl}reporte-comercializador/detalle/bulk`;
        return this.http
            .post<DetalleReporte>(url, detalleReporte)
            .pipe(catchError(this.handleErrorResponse));
    }

    FinalizarReporte(id: number, detalleReporte: {}) {
        const url = `${this.apiSiriUrl}reporte/${id}`;
        return this.http
            .put<{}>(url, detalleReporte)
            .pipe(catchError(this.handleErrorResponse));
    }

    private handleErrorResponse(error: HttpErrorResponse) {
        console.error(error.error.message);
        return throwError(error.error.message);
    }

    getReportePeriodoAnterior(id: number, anio: number, periodo: string) {
        const url = `${this.apiSiriUrl}reporte/periodo-anterior/${id}?anio=${anio}&periodo=${periodo}`;
        return this.http.get<ReporteForValidation | null>(url);
    }
}
